import { logUtil } from 'packages/src'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'
import {
  EXERCISE_KEY,
  getByIdMediaSelector,
  getVideoMediaIdByExerciseIdSelector,
  MEDIA_MODEL_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import getNameReduxUtil from 'modules/redux/utils/get-name/index.js'
import interpolateRouteUtil from 'modules/routes/utils/interpolate/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import getDescriptionByIdExerciseSelector from 'modules/exercise/redux/selectors/get-description-by-id/index.js'
import getTitleExerciseUtil from 'pages/Exercise/components/Wrapper/utils/get-title/index.js'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'

/**
 * @param props
 * @param props.instance
 * @param props.state
 * @param props.intl
 */
const getPagePropertiesExerciseUtil = (props) => {
  const {
    state,
    instance,
    intl
  } = props
  const id = getIdReduxUtil(instance)

  const logPrefix = `id=${id}`
  logUtil('getPagePropertiesExerciseUtil').debug(`${logPrefix} [start]`)

  const mediaId = getVideoMediaIdByExerciseIdSelector(id)(state)
  const media = getByIdMediaSelector(mediaId)(state)
  const exerciseName = getValueReduxUtil(instance, EXERCISE_KEY.NAME)
  const posterUrl = getValueReduxUtil(media, MEDIA_MODEL_KEY.THUMBNAIL)
  const slug = getSlugExerciseNameUtil(
    getNameReduxUtil(instance)
  )
  const url = interpolateRouteUtil(
    ROUTE_PATH.VIEW_EXERCISE_SLUG,
    {
      id,
      slug
    }
  )

  const description = getDescriptionByIdExerciseSelector({
    id,
    intl,
    isShort: true
  })(state)

  return {
    title: getTitleExerciseUtil({
      exerciseName,
      intl
    }),
    description,
    image: posterUrl,
    url
  }
}

export default getPagePropertiesExerciseUtil
